import { Link } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { MARKDOWN_TILLAGG } from '../lib/markdown'
import kursplanGy11 from '../statiskt/kursplan-gy11.md?raw'
import { useSidTitel } from '../lib/seo'

/** Den arkiverade kursplanen (Gy11, kurskod LEDLED0) — sökbarhet för lärare
 *  som undervisat sedan innan Gy25 och som söker på "gamla kursplanen
 *  ledarskap och organisation" eller kurskoden. Länkad från /kursplan och
 *  från jämförelseanalysen på /kursplan/andringar. */
export default function KursplanGy11() {
  useSidTitel('Gamla kursplanen (Gy11, LEDLED0) — arkiverad')
  return (
    <div className="wrap">
      <article className="dokument">
        <p className="kursplan-arkiv-etikett">Arkiverad kursplan · upphörde 2026-01-01</p>
        {/* Texten i src/statiskt/kursplan-gy11.md är ORDAGRANT Skolverkets
            gamla ämnesplan (hämtad via Skolverkets öppna Syllabus API,
            2026-08-18) — formulera aldrig om den. */}
        <ReactMarkdown remarkPlugins={MARKDOWN_TILLAGG}>{kursplanGy11}</ReactMarkdown>
        <p className="kalla-not">
          Källa: Skolverkets öppna Syllabus API (ämneskod LED, kurskod LEDLED0). Kursplanen
          gällde gymnasieskolans Gy11-reform från 2011 och upphävdes den 1 januari 2026
          (Skolfs 2025:66) när Gy25 infördes. Den återges här i sin helhet som referens och
          jämförelsematerial — inte som gällande kursplan.
        </p>
        <p className="kursplan-arkiv-lankar">
          <Link to="/kursplan">Gällande kursplan (Gy25, LEDA)</Link>
          {' · '}
          <Link to="/kursplan/andringar">Vad har ändrats mellan Gy11 och Gy25?</Link>
        </p>
      </article>
    </div>
  )
}
